import React, {useState} from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import UpdateToDoList from '../../ToDoList/UpdateToDoList/UpdateToDoList';
import AddToDoList from '../../ToDoList/AddToDoList/AddToDoList';
import InfoToDoList from '../../ToDoList/InfoToDoList/InfoToDoList';
import './ToDoList.css';
import {faTrashAlt, faPencilAlt, faCheck, faXmark} from '@fortawesome/free-solid-svg-icons';
import {Row, Col} from 'react-bootstrap';
import {MDBContainer, MDBRow} from 'mdb-react-ui-kit';
import {Button} from 'react-bootstrap';

/**
 *  L'accueil
 * @param {*} props props
 * @return {JSX}
 */
function ToDoListView(props) {
  const [isModalOpenAdd, setIsModalOpenAdd] = useState(false);
  const [isModalOpenUpdate, setIsModalOpenUpdate] = useState(false);
  const [isModalOpenInfo, setIsModalOpenInfo] = useState(false);
  const [toDoListSelected, setToDoListSelected] = useState({});


  /**
  * Ouvre le modal
  */
  function openModalAdd() {
    document.getElementById('navbar').classList.add('navbar-hidden');
    document.body.classList.add('modal-open');
    setIsModalOpenAdd(true);
  }

  const closeModalAdd = () => {
    document.getElementById('navbar').classList.remove('navbar-hidden');
    document.body.classList.remove('modal-open');
    setIsModalOpenAdd(false);
  };

  /**
   * open modal update
   */
  function openModalUpdate() {
    document.getElementById('navbar').classList.add('navbar-hidden');
    document.body.classList.add('modal-open');
    setIsModalOpenUpdate(true);
  }

  const closeModalUpdate = () => {
    document.getElementById('navbar').classList.remove('navbar-hidden');
    document.body.classList.remove('modal-open');
    setIsModalOpenUpdate(false);
  };

  /**
   * Open modal info
   */
  function openModalInfo() {
    // document.getElementById('navbar').classList.add('navbar-hidden');
    // document.body.classList.add('modal-open');
    // setIsModalOpenInfo(true);
  }

  const closeModalInfo = () => {
    document.getElementById('navbar').classList.remove('navbar-hidden');
    document.body.classList.remove('modal-open');
    setIsModalOpenInfo(false);
  };

  return (
    <div className="chantierinfo-container">
      <Button
        style={{backgroundColor: '#212529', color: 'white', marginBottom: '15px', marginTop: '0px'}}
        onClick={() => openModalAdd()}>
        Ajouter une TodoList
      </Button>
      {isModalOpenUpdate && (
        <MDBContainer className="modal" >
          <MDBRow className="d-flex justify-content-center align-items-center h-100 banktable-modal-content">
            <UpdateToDoList todolist={toDoListSelected} closeModal={closeModalUpdate}/>
          </MDBRow>
        </MDBContainer>)}

      {isModalOpenAdd && (
        <MDBContainer className="modal" >
          <MDBRow className="d-flex justify-content-center align-items-center h-100 banktable-modal-content">
            <AddToDoList closeModal={closeModalAdd}/>
          </MDBRow>
        </MDBContainer>)}

      {isModalOpenInfo && (
        <MDBContainer className="modal" >
          <MDBRow className="d-flex justify-content-center align-items-center h-100 banktable-modal-content">
            <InfoToDoList closeModal={closeModalInfo} todolist={toDoListSelected}/>
          </MDBRow>
        </MDBContainer>)}

      <h2 className="todolist-heading">Liste de tâches</h2>
      <input
        type="text"
        value={props.searchInput}
        onChange={props.handleSearchInput}
        className="todolist-input-hidden"
        placeholder="Barre de recherche" />
      <div className="todolist-wrapper">
        <div className="todolist-table">
          <div className="todolist-table">
            <Row key="1" className="todolist-row todolist-header">
              <Col md={9} className="todolist-cell">
              Description
              </Col>
              <Col md={1} className="todolist-cell">
              Complété
              </Col>

              <Col md={2} className="todolist-cell">
              </Col>
            </Row>
            {props.displayedToDoList.map((todolist, index) => (
              <React.Fragment key={index} >
                <Row key={index} className="todolist-row todolist-row-cell-click todolist-not-complete" >
                  <Col md={9} className="todolist-cell todolist-cell-click tooltips" style={{cursor: 'pointer'}} data-title="Description" onMouseEnter={() => {
                    setToDoListSelected(todolist); openModalInfo();
                  }}>
                    {todolist.description}
                    <div className="tooltiptext">
                      <div>Date créée: {toDoListSelected.date_ajoute}</div>
                      <div>Date complété: {toDoListSelected.date_complete}</div>
                      <div>Employé ajouté: {toDoListSelected.user_id_add}</div>
                      <div>Employé complété: {toDoListSelected.user_id_complete}</div>
                    </div>
                  </Col>
                  <Col md={1} className="todolist-cell todolist-cell-click tooltips" style={{cursor: 'pointer'}} data-title="Complété" onClick={() => openModalInfo()}>
                    {todolist.complete ? <FontAwesomeIcon icon={faCheck} style={{fontSize: '25px', color: 'green'}} /> : <FontAwesomeIcon icon={faXmark} style={{fontSize: '25px', color: 'red'}} />}
                    <div className="tooltiptext">
                      <div>Date créée: {toDoListSelected.date_ajoute}</div>
                      <div>Date complété: {toDoListSelected.date_complete}</div>
                      <div>Employé ajouté: {toDoListSelected.user_id_add}</div>
                      <div>Employé complété: {toDoListSelected.user_id_complete}</div>
                    </div>
                  </Col>

                  <Col md={2} className="todolist-cell todolist-cell-center">
                    <React.Fragment>
                      <FontAwesomeIcon className="todolist-souris" icon={faPencilAlt} onClick={() => {
                        setToDoListSelected(todolist); openModalUpdate();
                      } } style={{marginRight: '35px', fontSize: '25px'}} />
                      <FontAwesomeIcon className="todolist-souris" style={{fontSize: '25px'}} icon={faTrashAlt} onClick={() => props.supprimer(todolist.id)} />
                    </React.Fragment>
                  </Col>

                </Row>
              </React.Fragment>
            ))}
          </div>

        </div>
      </div>
    </div>
  );
}

export default ToDoListView;
